module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as3911-a41b86c8759fccd861b43cb330bf0b20.jpg";